import React, { useState } from 'react';
import { history } from '../../../../../_helpers/history';
import { telehealthService as service } from '../../../../../_services/telehealth.service';
import { Alert, Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

function CancelAction({ telehealth }) {
  const [show, setShow] = useState(false);
  const [canceling, setCanceling] = useState(false);
  const handleClose = () => { setShow(false); }
  const handleShow = () => { setShow(true); }

  const [successMsg, setSuccessMsg] = useState('');
  const [failedMsg, setFailedMsg] = useState('');

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Cancel</Tooltip>}
    >
      <button
        title="Cancel"
        onClick={handleShow}
        className="btn btn-outline-primary btn-sm">
        <i className="fas fa-calendar-times"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Cancel Telehealth</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {successMsg && <div className="alert alert-success">{successMsg}</div>}
        {failedMsg && <div className="alert alert-danger">{failedMsg}</div>}

        <Alert variant='primary'>
          Are you sure you want to cancel this telehealth appointment?
        </Alert>

      </Modal.Body>

      <Modal.Footer>
        <Button onClick={() => {
          setCanceling(true);
          setSuccessMsg('');
          setFailedMsg('');

          service.cancel(telehealth)
            .then(() => {
              setCanceling(false);
              setSuccessMsg('Telehealth appointment has been canceled.');

              setTimeout(() => {
                handleClose();
                history.go(0);
              }, 1500);
            })
            .catch((error) => {
              setCanceling(false);

              setFailedMsg('Could not cancel the telehealth appointment. Please try again later.');
            });
        }}
          disabled={canceling}
          variant="primary"
        >
          {canceling ? 'Canceling...' : 'Yes'}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default CancelAction;